<form [formGroup]="formGroup" (ngSubmit)="submitForm()">
  <formly-form [form]="formGroup" [model]="formModel" [fields]="fields"></formly-form>
</form>
